import { FollowUpAccordionItem, FollowUpAccordionKeys } from './types';

export const FOLLOW_UP_ACCORDION_ITEMS: FollowUpAccordionItem[] = [
  { value: 'Открытые', key: FollowUpAccordionKeys.active },
  { value: 'Закрытые', key: FollowUpAccordionKeys.closed },
];
